export const BLOG_IMAGE_FALLBACK = '/assets/placeholders/blog-image.png';
const LEGACY_BLOG_IMAGE_FALLBACK = '/assets/placeholders/blog-image.svg';

const WORDPRESS_BASE_URL = 'https://greenlightcity.co.za';
const ABSOLUTE_URL_RE = /^(?:[a-z][a-z\d+.-]*:)?\/\//i;
const ROOT_ASSET_RE = /^[^/?#]+\.(?:png|jpe?g|webp|avif|gif|svg)$/i;
const LOCAL_ASSET_RE = /^(?:public\/)?(?:assets|images)\//i;
const WORDPRESS_UPLOAD_RE = /^\/?wp-content\//i;

export const normalizeMediaUrl = (value = '') => {
  const trimmed = String(value || '').trim();

  if (!trimmed) return '';
  if (trimmed === LEGACY_BLOG_IMAGE_FALLBACK) return BLOG_IMAGE_FALLBACK;
  if (/^(?:data|blob):/i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  if (ABSOLUTE_URL_RE.test(trimmed)) return trimmed;
  if (trimmed.startsWith('/')) return trimmed;
  if (LOCAL_ASSET_RE.test(trimmed)) return `/${trimmed.replace(/^public\//i, '')}`;
  if (WORDPRESS_UPLOAD_RE.test(trimmed)) return `${WORDPRESS_BASE_URL}/${trimmed.replace(/^\/+/, '')}`;
  if (ROOT_ASSET_RE.test(trimmed)) return `/${trimmed}`;

  // Plain labels like "hero image" should not be rendered as <img src>.
  if (!trimmed.includes('/') && !trimmed.includes('.')) return '';

  return trimmed;
};

export const applyImageFallback = (event, fallbackUrl = BLOG_IMAGE_FALLBACK) => {
  const target = event?.currentTarget;
  if (!target || target.dataset.fallbackApplied === 'true') return;
  target.dataset.fallbackApplied = 'true';
  target.src = fallbackUrl;
};
